module.exports = __webpack_public_path__ + "assets/img/plan1-5.acb8a4ad.png";